module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/design-tile-images/design-tile-06-fe2d808e66c06c6e7f5d297636e9b829.png";